/** ***
------------------------------------------------------------------------
DETECTIONS (IOCs) LIST PAGE
------------------------------------------------------------------------
  Severity
  Name
  Risk Score
  Detection Time
  Attack Sequence (Values: Attack Trail ID, None. Can hyperlink to Attack Details)
  Kill Chain Tactic
  Host Name (Hover Over - Host OS, Host Version, Local IP, MAC Address)
  Host Type
  User Name

** ***/
import { DATETIME_FORMAT } from '@/constants/datetime.constants'

const iocDetectionsMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'datetime',
        format: DATETIME_FORMAT,
        description: 'Detection Time',
        label: 'Detection Time',
        name: 'seenTime',
        'min-width': 150,
        sortable: true
      },
      {
        datatype: 'number',
        description: 'Detection Rule ID',
        label: 'Rule ID',
        sortable: true,
        'min-width': 100,
        name: 'ruleid'
      },
      {
        datatype: 'objectpath',
        description: 'Detection Rule',
        label: 'Rule',
        sortable: true,
        'min-width': 200,
        name: 'rule.name'
      },
      {
        datatype: 'string',
        description: 'Severity',
        label: 'Severity',
        sortable: true,
        'min-width': 120,
        name: 'detectionSeverity',
        display: 'colorTag',
        displayKey: [
          {
            key: 'HIGH',
            display: 'High',
            color: '#FEF0F0',
            textColor: '#BF3951',
            border: '0.5px solid #F5B0B0'
          },
          {
            key: 'MEDIUM',
            display: 'Medium',
            color: '#FAECD8',
            textColor: '#654B23',
            border: '0.5px solid #EDCB98'
          },
          {
            key: 'LOW',
            display: 'Low',
            color: '#FDF6EC',
            textColor: '#654B23',
            border: '0.5px solid #EDCB98'
          },
          {
            key: 'CRITICAL',
            display: 'Critical',
            color: '#FDE2E2',
            textColor: '#732231',
            border: '0.5px solid #F5B0B0'
          }
        ]
      },
      {
        datatype: 'objectpath',
        description: 'Progression ID',
        display: 'link',
        label: 'Progression ID',
        'min-width': 150,
        pathTo: 'attack-track-details',
        params: {
          name: 'trailId',
          keyLookup: 'trailList.trailIdHash'
        },
        sortable: true,
        name: 'trailList.trailIdLabel'
      },
      {
        datatype: 'objectpath',
        description: 'MITRE Tactic',
        label: 'MITRE Tactic',
        'min-width': 150,
        sortable: true,
        name: 'iocTactic',
        display: 'mitrelink',
        link: 'rule.externalTacticUrl',
        linkLabel: {
          labelId: 'rule.tactic',
          labelName: 'rule.mitreAttackTactic.name'
        }
      },
      {
        datatype: 'objectpath',
        description: 'MITRE Technique',
        label: 'MITRE Technique',
        'min-width': 250,
        sortable: true,
        name: 'iocTactic',
        display: 'mitrelink',
        link: 'rule.externalTechniqueUrl',
        linkLabel: {
          labelId: 'rule.technique',
          labelName: 'rule.mitreAttackTechnique.name'
        }
      },
      {
        datatype: 'objectpath',
        description: 'Hostname',
        display: 'link',
        label: 'Hostname',
        'min-width': 200,
        sortable: true,
        name: 'host.customHostname',
        pathTo: 'host-insights',
        params: {
          name: 'agentId',
          keyLookup: 'host.agentId'
        }
      },
      {
        datatype: 'objectpath',
        description: 'Operating System',
        display: 'icon',
        label: 'Host OS',
        name: 'host.system.os',
        displayKey: [
          { key: 'linux', icon: 'fab fa-linux' },
          { key: 'windows', icon: 'fab fa-windows' }
        ]
      },
      {
        datatype: 'objectpath',
        description: 'Local IP',
        display: 'array',
        label: 'Local IP',
        sortable: true,
        'min-width': 200,
        name: 'host.localIPs'
      },
      {
        datatype: 'string',
        description: 'Detection State',
        display: 'stateTag',
        label: 'State',
        name: 'state',
        'min-width': 100,
        displayKey: [
          {
            key: 'ACTIVE',
            display: 'Active',
            color: '#b0e9d1',
            textColor: '#00602e'
          },
          {
            key: 'INACTIVE',
            display: 'Inactive',
            color: '#c6cbd2',
            textColor: '#292c32'
          },
          {
            key: 'MITIGATED',
            display: 'Mitigated',
            color: '#1a90fa',
            textColor: '#154db5'
          },
          {
            key: 'REOPENED',
            display: 'Reopened',
            color: '#de2e52',
            textColor: '#901747'
          }
        ]
      }
    ]
  }
}

export { iocDetectionsMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/detections/ioc-detections-meta.js